/**
 * 订单详情抽屉 - 特殊说明区块
 *
 * 展示订单的特殊说明内容。受控组件，不持有业务状态。
 */

interface Props {
  instructions: string | null;
}

export default function SpecialInstructionsSection({ instructions }: Props) {
  return (
    <>
      {/* Special instructions - moved here below Schedule */}
      {instructions && (
        <div>
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">特殊说明</p>
          <div className="bg-amber-50 border border-amber-100 rounded-xl p-4">
            <p className="text-sm text-amber-800 leading-relaxed">{instructions}</p>
          </div>
        </div>
      )}
    </>
  );
}